import React from "react";
import {ActionRow, ActionRowButton, Icon, PageHeading} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {PlusIcon} from "@heroicons/react/20/solid";
import {Route} from "@/routing/Router";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";
import {generateBreadcrumbs} from "@widgets/layout/Breadcrumbs";

type Props = {
    route: Route,
    isFetching: boolean,
    onNew: () => void,
};

const OptionGroupsOverviewHeading = ({route, isFetching, onNew}: Props) => {
    const intl = useIntl();

    return (
        <div className={"flex flex-col gap-4"}>
            <PageHeading
                breadcrumbs={generateBreadcrumbs(route, intl)}
                title={intl.formatMessage({id: "optionGroups"})}
                meta={<LocationPageMeta/>}
                actionRowHorizontal={false}
                actionRow={
                    <ActionRow>
                        <ActionRowButton
                            color={"primary"}
                            iconBefore={<Icon icon={PlusIcon}/>}
                            disabled={isFetching}
                            buttonAction={{
                                as: "button",
                                actionProps: {
                                    onClick: onNew,
                                },
                            }}
                        >
                            <FormattedMessage id={"newOptionGroup"}/>
                        </ActionRowButton>
                    </ActionRow>
                }
                breakpoints={{md: {actionRowHorizontal: true}}}
            />

            <p className={"w-full text-sm max-w-[600px] text-gray-500 dark:text-slate-400"}>
                <FormattedMessage id={"optionGroups.description"}/>
            </p>
        </div>
    );
};

export default OptionGroupsOverviewHeading;